import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { AppGlobals } from '@app/app.global';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityService implements OnInit {
  entitiesSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  entitiesSubject$ = this.entitiesSubject.asObservable();
  entitiesSubjectTDC: BehaviorSubject<{ id: string, name: string }[]> = new BehaviorSubject<{ id: string, name: string }[]>([]);
  entitiesSubjectTDC$ = this.entitiesSubjectTDC.asObservable();
  selectedEntities: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  selectedEntities$ = this.selectedEntities.asObservable();
  singleSelectedEntity: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  singleSelectedEntity$ = this.singleSelectedEntity.asObservable();

  singleDropdownCompanies: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  singleDropdownCompanies$ = this.singleDropdownCompanies.asObservable();

  singleSelectedCompany: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  singleSelectedCompany$ = this.singleSelectedCompany.asObservable();

  selectedEntitiesTDC: BehaviorSubject<{ id: string, name: string }[]> = new BehaviorSubject<{ id: string, name: string }[]>([]);
  selectedEntitiesTDC$ = this.selectedEntitiesTDC.asObservable();
  entitiesChanges: BehaviorSubject<{ isEntityChanged: boolean }> = new BehaviorSubject<{ isEntityChanged: boolean }>({ isEntityChanged: false });
  entitiesChanges$ = this.entitiesChanges.asObservable();
  entitiesChangesTDC: BehaviorSubject<{ isEntityChanged: boolean }> = new BehaviorSubject<{ isEntityChanged: boolean }>({ isEntityChanged: false });
  entitiesChangesTDC$ = this.entitiesChangesTDC.asObservable();

  public dataSubject = new BehaviorSubject<any[]>([]);
  public companies$: Observable<any[]> = this.dataSubject.asObservable();

  private dataSubjectProductTags = new BehaviorSubject<any[]>([]);
  public productTags$: Observable<any> = this.dataSubjectProductTags.asObservable();

  private dataSubjectCompany = new BehaviorSubject<any[]>([]);
  public companyDetails$: Observable<any> = this.dataSubjectCompany.asObservable();

  currentCompanySelection = new BehaviorSubject<any>({});
  currentCompanySelection$ = this.currentCompanySelection.asObservable();


  constructor(
    private appGlobals: AppGlobals, private http: HttpClient) { }

  ngOnInit(): void {
    if (localStorage.getItem('entities')) {
      this.entitiesSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('entities')));
    } else {
      this.entitiesSubject = new BehaviorSubject([]);
    }
  }

  setInitialEntities(companies, user) {
    let entityList = [];
    companies.forEach((company) => {
      // entityList.push({
      //   id: company?.id,
      //   group: company?.name, // this will group all outlets under company
      //   name: company?.name,
      //   parent: null,
      //   isSelected: false,
      //   parentId: company.id
      // });

      company.outlets?.forEach((outlet) => {
        entityList.push({
          id: outlet.id,
          group: company.name, // this will group all outlets under company
          name: outlet.name,
          parent: company.id,
          isSelected: false,
          parentId: company.id,
          maxInvoicePageCount: outlet.maxInvoicePageCount,
          subscriptionDate: outlet.subscriptionDate,
          isPaidCompany: outlet.isPaidCompany
        });
      });
    });

    this.setEntities(entityList);
    // this.setSelectedEntities(entityList);

    this.setInitialCompanies(companies);
    return;
  }

  setInitialCompanies(companies) {
    let companyList = [];
    companies.forEach((company) => {
      if (!company.parent) {
        companyList.push({
          id: company.id,
          group: company.name,
          name: company.name,
          isSelected: false,
          isPaidCompany: company.isPaidCompany,
          subscriptionDate: company.subscriptionDate,
        })
      }
    });
    this.setSingleDropdownCompanies(companyList);
  }

  setEntities(entities) {
    localStorage.setItem('entities', JSON.stringify(entities));
    this.entitiesSubject?.next(entities);
  }

  setEntitiesTDC(entities) {
    localStorage.setItem('entitiesTDC', JSON.stringify(entities));
    this.entitiesSubjectTDC?.next(entities);
  }

  getEntities(): any {
    if (this.entitiesSubject?.value?.length) {
      return this.entitiesSubject.value;
    }

    if (localStorage.getItem('entities')) {
      return JSON.parse(localStorage.getItem('entities'));
    }

    return [];
  }

  getSingleDropdownCompanies() {
    if (this.singleDropdownCompanies?.value?.length) {
      return this.singleDropdownCompanies?.value;
    }

    if (localStorage.getItem('singleDropdownCompanies')) {
      return JSON.parse(localStorage.getItem('singleDropdownCompanies'));
    }

    return [];
  }

  getSingleSelectedCompany() {
    if (this.singleSelectedCompany?.value?.length) {
      return this.singleSelectedCompany?.value;
    }

    if (localStorage.getItem('singleSelectedCompany')) {
      return JSON.parse(localStorage.getItem('singleSelectedCompany'));
    }

    return null;
  }

  setSelectedEntities(entities) {
    localStorage.setItem('selectedEntities', JSON.stringify(entities));
    this.selectedEntities.next(entities);
  }

  setSingleSelectedEntity(entity) {
    localStorage.setItem('singleSelectedEntity', JSON.stringify(entity));
    this.singleSelectedEntity.next(entity);
  }

  setSingleSelectedCompany(company) {
    localStorage.setItem('singleSelectedCompany', JSON.stringify(company));
    this.singleSelectedCompany.next(company);
  }

  setSingleDropdownCompanies(companies) {
    localStorage.setItem('singleDropdownCompanies', JSON.stringify(companies));
    this.singleDropdownCompanies.next(companies);
  }

  setSelectedEntitiesTDC(entities) {
    localStorage.setItem('selectedEntitiesTDC', JSON.stringify(entities));
    this.selectedEntitiesTDC.next(entities);
  }

  getSelectedEntities() {
    if (this.selectedEntities?.value?.length) {
      return this.selectedEntities.value;
    } else if (localStorage.getItem('selectedEntities')) {
      return JSON.parse(localStorage.getItem('selectedEntities'));
    }
    return [];
  }

  getSelectedCompanyForKYC() {
    const selectedEntities = this.getSelectedEntities();
    if (selectedEntities?.length) {
      return selectedEntities[0]?.parent;
    }

  }

  getSelectedEntitiesTDC() {
    if (this.selectedEntitiesTDC.value.length) {
      return this.selectedEntitiesTDC.value;
    } else if (localStorage.getItem('selectedEntitiesTDC')) {
      return JSON.parse(localStorage.getItem('selectedEntitiesTDC'));
    }
    return [];
  }

  getSingleSelectedEntity() {
    if (this.singleSelectedEntity.value) {
      return this.singleSelectedEntity.value;
    } else if (localStorage.getItem('singleSelectedEntity')) {
      return JSON.parse(localStorage.getItem('singleSelectedEntity'));
    }
  }

  setLastSelectedEntities(entities) {
    localStorage.setItem('lastSelectedEntities', JSON.stringify(entities));
  }

  setLastSelectedEntitiesTDC(entities) {
    localStorage.setItem('lastSelectedEntitiesTDC', JSON.stringify(entities));
  }

  getLastSelectedEntities() {
    return JSON.parse(localStorage.getItem('lastSelectedEntities'));
  }

  getLastSelectedEntitiesTDC() {
    return JSON.parse(localStorage.getItem('lastSelectedEntitiesTDC'));
  }

  setLastSelectedCompany(company) {
    localStorage.setItem('lastSelectedCompany', JSON.stringify(company));
  }

  setLastSelectedCompanyTDC(company) {
    localStorage.setItem('lastSelectedCompanyTDC', JSON.stringify(company));
  }

  getLastSelectedCompany() {
    return JSON.parse(localStorage.getItem('lastSelectedCompany'));
  }

  getLastSelectedCompanyTDC() {
    return JSON.parse(localStorage.getItem('lastSelectedCompanyTDC'));
  }

  setEntitiesChanges(entityChange) {
    this.entitiesChanges.next(entityChange);
  }

  setEntitiesChangesTDC(entityChange) {
    this.entitiesChangesTDC.next(entityChange);
  }

  // fetchEntities(): Observable<OEntity[]> {
  //   return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}entity/list`).pipe(
  //     map((entities: IEntity[]) => entities.map((entity: IEntity) => new OEntity(entity)))
  //   );
  // }
  fetchEntities(): Observable<any[]> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}entity/list`)
    // .pipe(
    //   map((entities: IEntity[]) => entities.map((entity: IEntity) => new OEntity(entity)))
    // );
  }

  companyUser(): Observable<any[]> {
    return this.http.get<any>(`${this.appGlobals.apiUrl.metadata}company/user`);
  }

  setCompanies(queryParams?: any): Observable<any[]> {
    if (!queryParams?.name) {
      const searchCompany = localStorage.getItem('searchCompany');
      if (searchCompany) {
        queryParams = { name: searchCompany }
      }
    }

    return this.http.get<any[]>(`${this.appGlobals.apiUrl.metadata}company/user`, {
      params: queryParams
    });
  }

  fetchCompanies() {
    this.setCompanies().subscribe({
      next: (response: any) => {
        if (response.company?.length) {
          this.dataSubject.next(response)
        } else {
          localStorage.removeItem('searchCompany');
          this.setCompanies().subscribe({
            next: (response: any) => {
              if (response.company?.length) {
                this.dataSubject.next(response)
              }
            }
          });
        }
      }
    });
  }

  getCompanies(): any[] {
    return this.dataSubject.value;
  }

  setProductTags(data) {
    this.dataSubjectProductTags.next(data)
  }

  setCompanyDetails(data) {
    this.dataSubjectCompany.next(data)
  }

  setCurrentCompanySelection(data) {
    this.currentCompanySelection.next(data);
    localStorage.setItem('currentCompanySelection', JSON.stringify(data));
  }

  getCurrentCompanySelection() {
    if (this.currentCompanySelection.value && Object.keys(this.currentCompanySelection.value).length) {
      return Array.isArray(this.currentCompanySelection.value)
        ? this.currentCompanySelection.value
        : [this.currentCompanySelection.value];
    } else if (localStorage.getItem('currentCompanySelection')) {
      const stored = JSON.parse(localStorage.getItem('currentCompanySelection'));
      return Array.isArray(stored) ? stored : [stored];
    } else {
      return [];
    }

  }

}
